var _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgWindDirection = function SvgWindDirection(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 200 200",
    focusable: false,
    "aria-hidden": true
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "wind_direction_svg2__a",
    x1: -11.24,
    x2: 139.76,
    y1: 158.19,
    y2: 14.19,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#3d43c1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#a80096"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#wind_direction_svg2__a",
    id: "wind_direction_svg2__b",
    x1: 49.02,
    x2: 200.02,
    y1: 221.39,
    y2: 77.39
  }), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#wind_direction_svg2__a",
    id: "wind_direction_svg2__c",
    x1: 44.48,
    x2: 195.48,
    y1: 216.62,
    y2: 72.62
  }), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#wind_direction_svg2__a",
    id: "wind_direction_svg2__d",
    x1: 18.24,
    x2: 169.24,
    y1: 189.11,
    y2: 45.11
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M189.6 37.3 74.89.57C71.27-.6 67.42.03 64.34 2.28c-1.58 1.16-2.8 2.65-3.63 4.33l-.08-.08-37.96 37.94c-2.25-3.24-5.98-5.38-10.22-5.38C5.59 39.09 0 44.68 0 51.54V200h24.89V60.82l35.72 35.72.08-.08c.83 1.69 2.05 3.18 3.63 4.34 2.06 1.5 4.47 2.28 6.92 2.28 1.21 0 2.44-.19 3.63-.58l114.72-36.73c6.31-2.02 10.39-7.61 10.39-14.23s-4.08-12.21-10.39-14.23m-30.49-1.7v31.85l-25.51 8.17V27.44zM59.49 84.54 30.33 55.38h29.16zm0-36.85H30.33l29.16-29.16zM7.7 74.54h9.51v117.77H7.7zm9.5-7.7H7.7V51.53c0-2.62 2.13-4.75 4.75-4.75 2.15 0 3.9 1.47 4.48 3.43l-1.32 1.32 1.59 1.59v13.71Zm55.34 28.34c-1.27.4-2.6.18-3.68-.6a4.06 4.06 0 0 1-1.68-3.32V11.81c0-1.33.62-2.54 1.68-3.32a4.1 4.1 0 0 1 2.41-.79c.42 0 .85.07 1.27.2l20.15 6.45v19.6h7.69V16.81l25.51 8.17v53.11l-25.51 8.17V69.12h-7.69v19.6l-20.15 6.45Zm114.72-36.73L166.79 65V38.07l20.47 6.55c3.72 1.19 5.04 4.35 5.04 6.91s-1.32 5.72-5.04 6.91",
    style: {
      fill: "url(#wind_direction_svg2__a)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M168.98 95.38c-10.74 0-19.48 8.74-19.48 19.48h7.69c0-6.5 5.29-11.79 11.79-11.79s11.79 5.29 11.79 11.79-5.29 11.79-11.79 11.79h-57.07v7.69h57.07c10.74 0 19.48-8.74 19.48-19.48s-8.74-19.48-19.48-19.48",
    style: {
      fill: "url(#wind_direction_svg2__b)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96.54 146.19h35.51v7.69H96.54z",
    style: {
      fill: "url(#wind_direction_svg2__c)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45 146.19h28.43v7.69H45z",
    style: {
      fill: "url(#wind_direction_svg2__d)"
    }
  }));
};
export default SvgWindDirection;